exports.install = function (Vue) {
    Vue.prototype.goMain = function (path) {
        this.$router.push({
            path: path
        })
    };

    //验证浏览器
    Vue.prototype.jumpNavigator = function getBrowser() {
        var UserAgent = navigator.userAgent.toLowerCase();
        var browser = null;
        var browserArray = {
            IE: window.ActiveXObject || "ActiveXObject" in window, // IE
            Chrome: UserAgent.indexOf('chrome') > -1 && UserAgent.indexOf('safari') > -1, // Chrome浏览器
            Firefox: UserAgent.indexOf('firefox') > -1, // 火狐浏览器
            Opera: UserAgent.indexOf('opera') > -1, // Opera浏览器
            Safari: UserAgent.indexOf('safari') > -1 && UserAgent.indexOf('chrome') == -1, // safari浏览器
            Edge: UserAgent.indexOf('edge') > -1, // Edge浏览器
            QQBrowser: /qqbrowser/.test(UserAgent), // qq浏览器
            WeixinBrowser: /MicroMessenger/i.test(UserAgent) // 微信浏览器
        };
        for (var i in browserArray) {
            if (browserArray[i]) {
                browser = i;
            }
        }

        return browser;
    };
}





// WEBPACK FOOTER //
// ./src/page/function/fun.js